import { FC } from 'react';
import styled from 'styled-components';
import { Switch } from 'antd';
import { colorGray, colorOrange } from '@atlas-frontend/design-tokens';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ToggleUserReadComment.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'toggle-input-data-processing-event-status-switch',
);
addTranslations(translations);

export interface ToggleToggleUserReadCommentProps {
  isRead: boolean;
  setCommentRead: () => void;
}

export const ToggleUserReadComment: FC<ToggleToggleUserReadCommentProps> = (
  props,
) => {
  const { t } = useTranslation();
  const { isRead, setCommentRead } = props;

  return (
    <StyledSwitch
      checkedChildren={t('status.read')}
      unCheckedChildren={t('status.unread')}
      checked={isRead}
      onClick={setCommentRead}
      disabled={isRead}
      $noHandle={isRead}
    />
  );
};

const StyledSwitch = styled(Switch)<{ $noHandle: boolean }>`
  background-color: ${colorOrange[2]};

  &:hover:not(.ant-switch-disabled) {
    background-color: ${colorOrange[3]};
  }

  &.ant-switch-checked {
    background-color: ${colorGray[2]};

    &:hover:not(.ant-switch-disabled) {
      background-color: ${colorGray[4]};
    }
  }

  .ant-switch-inner {
    .ant-switch-inner-checked,
    .ant-switch-inner-unchecked {
      color: black;
    }
  }

  ${({ $noHandle }) =>
    $noHandle
      ? `
    .ant-switch-handle {
      display: none;
    }
    .ant-switch-inner {
      padding-inline: 9px !important;
    }
  `
      : ''}
`;
